import {
  paymentAgreementPolyllmDefault,
  paymentAgreementPolyllmUs,
} from '~/projects/polyllm-chat/config/agreementCopy';
import { ProjectRuntimeBehavior } from '~/projects/types';

const runtimeBehavior: ProjectRuntimeBehavior = {
  title: 'ChatWithAI',
  fetchSubscriptionEndpoint: false,
  createFunnelUserBeforeSignUp: true,
  fetchTrustpilotInviteUrl: false,
  subscriptionFromProfileOnly: true,
  showSubscriptionUsageBlocks: false,
  withOnboardingMiddleware: false,
  settingsMainLayoutNoSidebar: true,
  loadDesktopSidebarThemeToggle: true,
  chatVendorDefaultIsGpt51: true,
  chatVendorSelectorAvailableWithoutFeatureFlag: true,
  chatUsesGptShellLayout: true,
  chatAnonymousSessionsEnabled: true,
  chatUsesChatwithaiEndpoints: true,
  showFrozenSubscriptionBlock: false,
  showHomeRetentionPopover: false,
  showTrustpilotMentions: false,
  backendErrorsHandlingStrategy: 'polyllm_upgrade_paywall',
  signUpUsesDeviceIdHeader: true,
  showNoActiveSubscriptionModal: false,
  paymentConfigByRegion: {
    US: { getCompanyAddress: paymentAgreementPolyllmUs },
    default: { getCompanyAddress: paymentAgreementPolyllmDefault },
  },
};

export default runtimeBehavior;
